// HOTWIRED + TURBO
import * as Turbo from "@hotwired/turbo";

// FITTY (homepage ...)
import fitty from 'fitty';

// SWIPER (projects)
import { register } from 'swiper/element/bundle';
import 'swiper/css/pagination';
register();

// ALPINE
import "alpine-turbo-drive-adapter";
import Alpine from "alpinejs";
import intersect from "@alpinejs/intersect";
import collapse from "@alpinejs/collapse";
import focus from '@alpinejs/focus'

Alpine.plugin(intersect);
Alpine.plugin(collapse);
Alpine.plugin(focus);
window.Alpine = Alpine;

// TOUCH
function isTouchDevice() {
  return (('ontouchstart' in window) ||
     (navigator.maxTouchPoints > 0) ||
     (navigator.msMaxTouchPoints > 0));
}
const myFlag = isTouchDevice();

document.addEventListener("turbo:load", function () {
	Alpine.start();

	// https://github.com/rikschennink/fitty/
	// homepage: fit text in box width
	fitty('h1.claim', {
    maxSize: 130,
	});

	// swiper
  const swiperEl = document.querySelector('swiper-container');
	if (swiperEl) initSwiper(swiperEl)
	
	// detect touch
	const body = document.getElementsByTagName('body')[0];
	if (isTouchDevice()) body.classList.add('touch');

});


function initSwiper(swiperEl){
	// size
	// const height = window.innerHeight / 2

	// swiper parameters
  const swiperParams = {
		// modules: [Navigation],
    // slidesPerView: 1,
		// loop: true,
		// height: height,
		// keyboardControl: true,
    navigation: {
		// 	nextEl: document.querySelector('.swiper-button-next'),
    //   prevEl: document.querySelector('.swiper-button-prev'),
		 	//hideOnClick: true,
		}
  };
	Object.assign(swiperEl, swiperParams);
  swiperEl.initialize();

  // swiperEl.addEventListener('swiperactiveindexchange', (event) => {
  //   const [swiper, progress] = event.detail;
	// 	console.log('progress ', swiper, event.detail);
  // });

	// SWIPER EVENTS
  swiperEl.addEventListener('swiperslidechange', (event) => {
		const [swiper] = event.detail;
		// update counter in alpinejs
		const e = new CustomEvent('myslidechange', { detail: {
				currentSlide: swiper.activeIndex+1,
				slidesTotal: swiper.slides.length,
			} 
		});
    document.dispatchEvent(e);
  });

	// toggle navi arrows
	swiperEl.addEventListener('click', (event) => {
		if (event.target != swiperEl) {
			let elm = swiperEl.shadowRoot.querySelector('.swiper-button-next')
			console.log(elm.style.opacity > 0.5, elm.style.opacity);
			elm.style.opacity = elm.style.opacity > 0.5 || elm.style.opacity=='' ? 0:1
			let elm2 = swiperEl.shadowRoot.querySelector('.swiper-button-prev')
			elm2.style.opacity = elm.style.opacity	
		}
		// console.log('cl', event.target == swiperEl);
	});

	swiperEl.addEventListener('swipertransitionstart', (event) => {
		// console.log('transitionStart ');
		// handle video files
		var videos = document.querySelectorAll('video');
		Array.prototype.forEach.call(videos, function(video){
			video.pause();
		});
  });

	swiperEl.addEventListener('swipertransitionend', (event) => {
		
		const [swiper] = event.detail;
		// handle video files
		var activeIndex = swiper.activeIndex;
		var activeSlide = document.getElementsByTagName('swiper-slide')[activeIndex];
		// console.log('swipertransitionend ', activeSlide);

		// VIDEO
		var activeSlideVideo = activeSlide.getElementsByTagName('video')[0];
		if (activeSlideVideo) {
			activeSlideVideo.play();
		}

		// MAP

		
  });

	// MAP IN SLIDER
	const mapElement = document.getElementById("slide_map");
  if (mapElement) {
		mapElement.style.height = (mapElement.offsetWidth * 2 / 3) + 'px';
    if (window.map) window.map = null;
		
    setTimeout(()=>{
			window.initMap(mapElement) // slide_map.js
		}, 1200);
  }

}

window.toggleFullscreen = function() {
	const elem = document.querySelector('.slider');
	if (!document.fullscreenElement) {
			elem.requestFullscreen().catch((err) => {
					alert(`Error attempting to enable fullscreen mode: ${err.message} (${err.name})`);
			});
	} else {
			document.exitFullscreen();
	}
}
